const ADMIN_ROLE = 'admin';
const CONTENT_EDITOR_ROLE = 'editor';
const CLINICAL_EDITOR_ROLE = 'clinical_editor';

const ROUTES_BY_ROLE = {
  [ADMIN_ROLE]: ['*'],
  [CONTENT_EDITOR_ROLE]: [
    '/admin/news',
    '/admin/blogs',
    '/admin/events',
    '/admin/projects',
    '/admin/donors-partners',
    '/admin/gallery'
  ],
  [CLINICAL_EDITOR_ROLE]: [
    '/admin/diseases',
    '/admin/tests-procedures',
    '/admin/symptom-browse',
    '/admin/services',
    '/admin/departments',
    '/admin/senior-management'
  ]
};

function normalizePath(pathname) {
  const s = String(pathname || '').trim();
  return s.endsWith('/') && s.length > 1 ? s.slice(0, -1) : s;
}

export function getRoleHomePath(role) {
  if (role === CONTENT_EDITOR_ROLE) return '/admin/news';
  if (role === CLINICAL_EDITOR_ROLE) return '/admin/diseases';
  return '/admin/dashboard';
}

export function canAccessAdminPath(role, pathname) {
  const path = normalizePath(pathname);
  if (!path.startsWith('/admin/')) return true;
  if (!role) return false;
  if (path === '/admin/change-password') return true;
  if (role === ADMIN_ROLE) return true;

  const allowed = ROUTES_BY_ROLE[role] || [];
  return allowed.some((base) => path === base || path.startsWith(`${base}/`));
}

export function getVisibleAdminMenuItems(role, menuItems) {
  if (role === ADMIN_ROLE) return menuItems;
  return menuItems.filter((item) => canAccessAdminPath(role, item.path));
}

export function getRoleBadgeVariant(role) {
  if (role === ADMIN_ROLE) return 'danger';
  if (role === CONTENT_EDITOR_ROLE) return 'warning';
  if (role === CLINICAL_EDITOR_ROLE) return 'info';
  return 'secondary';
}

export function formatRoleLabel(role) {
  if (role === ADMIN_ROLE) return 'Admin';
  if (role === CONTENT_EDITOR_ROLE) return 'Editor';
  if (role === CLINICAL_EDITOR_ROLE) return 'Clinical Editor';
  return role || 'User';
}

